import { getMicroserviceBaseContext } from '../../constants/api-routing';

const documentsContext = getMicroserviceBaseContext('documents');

export const DOCUMENTS_SERVICE = {
    downloadFile: `${documentsContext}veeva_vault_document_download`,
    getAMPDataSorceList: `${documentsContext}list_amp_metadata`,
    getAMPDataSorceListBySourceName: `${documentsContext}filter_amp_metadata_by_file`,
    getDetailDataSource: `${documentsContext}get_sharepoint_filepath_detail`,
    createDataPath: `${documentsContext}create_sharepoint_path`,
    getVeevaVaultMetadata: `${documentsContext}get_veeva_vault_metadata/`,
    updatePriority: `${documentsContext}update_veeva_vault_priority/`,
    updateStatus: `${documentsContext}update_veeva_vault_status/`,
    updateStatusActive: `${documentsContext}update_sharepoint_file_status`,
}
